import { render, staticRenderFns } from "./FaceZoom.vue?vue&type=template&id=0973215c&scoped=true"
import script from "./FaceZoom.vue?vue&type=script&lang=js"
export * from "./FaceZoom.vue?vue&type=script&lang=js"
import style0 from "./FaceZoom.vue?vue&type=style&index=0&id=0973215c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0973215c",
  null
  
)

export default component.exports